<script>
  import FlightEventHandler from './FlightEventHandler.svelte';
	import OwnshipTrail from './ownshipTrail'
</script>

<FlightEventHandler handlerClass={OwnshipTrail} />